import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["checkbox"]

  connect() {
    $(this.element)
      .on("show.bs.dropdown", () => this.toggleTableOverflow(true))
      .on("hidden.bs.dropdown", () => this.toggleTableOverflow(false))
  }

  disconnect() {
    $(this.element).off("show.bs.dropdown hidden.bs.dropdown")
  }

  toggleTableOverflow(open) {
    const tableResponsive = this.element.closest(".table-responsive")
    if (tableResponsive) tableResponsive.classList.toggle("column-filter-open", open)
  }

  stop(event) {
    event.stopPropagation()
  }

  clear(event) {
    event.stopPropagation()
    this.checkboxTargets.forEach((checkbox) => { checkbox.checked = false })
    this.element.closest("form").requestSubmit()
  }
}
